import { Injectable } from '@angular/core';
import { AccountEntity } from './account.entity';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionService } from '../subscription/subscription.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  public account: AccountEntity;

  static instance: AccountService;

  public get schedule() {
    return this.account?.settings?.schedule || {
      start: 7,
      end: 22
    };
  }

  public get locale() {
    return this.translate.defaultLang || 'en-US';
  }

  constructor(
    private router: Router,
    private translate: TranslateService,
    private subscriptionService: SubscriptionService
  ) { 
    AccountService.instance = this;
    // console.log("account translate", this.translate.getBrowserLang(), this.translate.getDefaultLang(), this.translate.getLangs())
  }

  public async init({id, name, email}) {
    try {
     this.account = await this.findById(id); // update account?

     if (!this.account) {
       this.account = await this.create({id, name, email});
        // await this.subscriptionService.subscribe();
     } else if (!this.account.name) {
  
       this.account.name = email.split('@')[0];
      await this.account.persist();
     }



    //  this.router.navigate(['/']);
    } catch(e) {
      console.log(e);
      this.account = new AccountEntity();
      this.account.id = id;
    }
    console.log("Locale:", this.locale, this.account)

  }

  public async create(data: {
    id: string;
    name?: string,
    email: string
  }) {
    this.account = new AccountEntity();
    
    this.account.id = data.id;
    this.account.email = data.email;
    this.account.name = data.name || data.email.split('@')[0];
    this.account.settings.language = this.locale;

    return await this.account.persist();
  }

  public async findByEmail(email: string) {
    return await AccountEntity.findIndex<AccountEntity>('email', email);
  }

  public async findById(id: string) {
    return await AccountEntity.load<AccountEntity>(id);
  }

  public set subscription(subscription: any) {
    this.subscriptionService.updateCurrent(subscription);
  }

  public set alreadyTrial(alreadyTrial: boolean) {
    this.subscriptionService.alreadyTrial = alreadyTrial;
  }
}
